import { useEffect, useState, useRef } from "react";
import axios from "axios";

const usePuntosCategoriaSubcategoria = (year, mes, token, idAdministrador, provinciaSeleccionada, ciudadSeleccionada) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const abortControllerRef = useRef(null);

  useEffect(() => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    
    const fetchData = async () => {
      try {
        setLoading(true);
        abortControllerRef.current = new AbortController();
        
         
        
        const response = await axios.post(
          `https://seguimientoconductor-nodejs-pits.com/administrador_seginus/obtenerPuntosCategoriaSubcategoria`,
          { 
            anio: year, 
            mes: mes, 
            provincia: provinciaSeleccionada || null,
            ciudad: ciudadSeleccionada || null,
            id_administrador: idAdministrador 
          },
          { 
            headers: { Authorization: token },
            signal: abortControllerRef.current.signal 
          }
        );
        
        if (response.data && response.data.success) {
          setData(response.data.data || []);
        } else {
          console.warn("⚠️ Respuesta inesperada en PuntosCategoriaSubcategoria:", response.data);
          setData([]);
        }
        setError(null);
      } catch (error) {
        if (error.name !== 'AbortError') {
           
          setError("Error al obtener datos de puntos por categoría");
          setData([]);
        }
      } finally {
        if (abortControllerRef.current) {
          setLoading(false);
        }
      }
    };
    
    if (token && idAdministrador) {
      fetchData();
    } else {
      setLoading(false);
    }
    
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [year, mes, token, idAdministrador, provinciaSeleccionada, ciudadSeleccionada]);

  return { data, loading, error };
};

export default usePuntosCategoriaSubcategoria;